// Environment configuration
export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'https://api.telviaiq.com',
  appName: 'telviaIQ',
  version: '1.0.0',
  supportEmail: 'support@speakiq.com',
  supportPhone: '2147164400',
  isProduction: import.meta.env.PROD,
  isDevelopment: import.meta.env.DEV,
} as const;

// Navigation configuration
// Note: Sidebar uses its own navItems array with actual icon components
// This config is kept for legacy header support and embed mode
export const navigationConfig = {
  mainNav: [
    { name: 'Command Hub', href: '/', icon: 'LayoutDashboard' },
    { name: 'Traffic & Usage', href: '/usage', icon: 'Activity' },
    { name: 'Phone Numbers', href: '/dids', icon: 'Phone' },
    { name: 'Port Orders', href: '/porting', icon: 'ArrowLeftRight' },
    { name: 'Order History', href: '/orders', icon: 'ShoppingCart' },
  ],
  embedNav: [
    { name: 'Phone Numbers', href: '/embed/dids', icon: 'Phone' },
  ],
} as const;

// DID service tabs configuration (for the detail modal)
export const didTabsConfig = [
  { id: 'failover', label: 'Failover', row: 1 },
  { id: 'forward', label: 'Forward', row: 1 },
  { id: 'fax-to-email', label: 'eFax', row: 1 },
  { id: 'conference', label: 'Conference', row: 1 },
  { id: 'caller-id-cnam', label: 'Caller ID / CNAM', row: 2 },
  { id: 'e911', label: 'E911', row: 2 },
] as const;

// Mutually exclusive services
export const mutuallyExclusiveServices = [
  'forward',
  'failover',
  'fax-to-email',
  'conferencing',
] as const;
